import { useContext } from 'react'

import { ParametrizationCurveExecutationContext } from '@provider/Parametrization/CurveExecutationProvider'

import { ICurveExecutationProvider } from '@base/@types/providers/Parametrization/CurveExecutationProvider'

export default function useParametrizationCurveExecutation(): ICurveExecutationProvider {
  const context = useContext(ParametrizationCurveExecutationContext)

  return context
}
